import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as BaseLink } from 'react-router-dom';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing(0.5)};
`;

export const Link = styled(BaseLink)`
  text-decoration: none;
  color: inherit;
`;
